export const layoutClassNames = Object.freeze({
  pageContainer: 'logto_page-container',
  mainContent: 'logto_main-content',
  customContent: 'logto_custom-content',
  signature: 'logto_signature',
  brandingHeader: 'logto_branding-header',
  /*
   * TDA: present only when `BrandingHeader` is drawing a THIRD-PARTY logo — the
   * "their app ⟷ us" row on the consent screen. `Layout/AppLayout` draws the
   * brand lockup for every screen, and that row already carries our logo, so the
   * lockup hides itself when this class is on the page. Unhashed on purpose: a
   * CSS-module hash would not survive a rebuild.
   */
  thirdPartyBrandingHeader: 'logto_third-party-branding-header',
  /*
   * TDA: the art panel beside the form. Stable and unhashed on purpose — it is
   * the hook per-organization `customCss` targets, so the tenant's background
   * image can be applied without knowing a CSS-module hash. The Control Plane
   * generates that rule; see `syncBrandingWithAssets`.
   */
});
